import React, { Component } from "react";
import { FormControl } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import _ from "lodash";
// No data found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import "../../routes/app";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    tagManagementTitle: "Tag Audit Trail",
    tagDesc: "Audit Trail of the tags",
    tagIDTitle: "Tag ID",
    auditTrailTimeTitle: "Audit Trail Time",
    userEmailTitle: "User Email",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
  },
  ja: {
    tagManagementTitle: "タグ監査履歴",
    tagDesc: "タグの監査履歴",
    tagIDTitle: "タグID",
    auditTrailTimeTitle: "監査履歴の時間",
    userEmailTitle: "ユーザーのメール",
    resultTitle1: "表示中 ",
    resultTitle2: " から ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
  },
  es: {
    tagManagementTitle: "Auditoría de Etiquetas",
    tagDesc: "Auditoría de las etiquetas",
    tagIDTitle: "ID de Etiqueta",
    auditTrailTimeTitle: "Hora de Auditoría",
    userEmailTitle: "Correo Electrónico del Usuario",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
  },
});

class TagAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lockListArray: [],
      tagDataArray: [],
      selectedLockSerial: "",
      loading: false,
    };
    // Deteching onChange
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);

    // Fetching of Data
    // this.fetchTagListData = this.fetchTagListData.bind(this);
    // this.timeStampFormat = this.timeStampFormat.bind(this);
    this.dateTimeFormat = this.dateTimeFormat.bind(this);

    // Force Update
    // this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    // Force Update
    this.renderDropdown = this.renderDropdown.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);

    this.createCustomSearchField = this.createCustomSearchField.bind(this);
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  componentWillMount() {
    fire
      .database()
      .ref("MyAdminLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        this.setState({
          lockListArray: tempArray,
        });
      });
  }

  fetchTagData(selectedTagSerial) {
    fire
      .database()
      .ref("tagAuditTrail")
      .child(selectedTagSerial)
      .orderByChild("auditTrailTime")
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        tempArray.reverse();
        this.setState({
          tagDataArray: tempArray,
        });
      });
  }

  // Render drop down list
  renderDropdown() {
    return _.map(this.state.lockListArray, (lockListData) => {
      return (
        <option value={lockListData.ip45SerialNumber}>
          {lockListData.ip45SerialNumber}
          {lockListData.lockAlias !== undefined &&
            ` - ${lockListData.lockAlias}`}
        </option>
      );
    });
    // return _.map(this.state.historicalRecipientsArray, data => {
    //   return <option value={data.email}>{data.email}</option>;
    // });
  }

  createCustomSearchField = (props) => {
    return <SearchField className="searchBar" placeholder="Search By ID" />;
  };

  dateTimeFormat(time) {
    customLog(time);
    customLog(localizationStrings.getLanguage());
    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time / 1000} format="full" includeDay />;
    }
  }

  detectOnChangeEvent(event) {
    var val = event.target.value;
    this.setState({
      selectedTag: val,
      count: 0,
    });
    var selectedTag = event.target.value;
    this.fetchTagData(selectedTag);
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  // timeStampFormat(timeStamp) {
  // 	return (
  // 		<TimeStamp time={timeStamp / 1000} format="full" includeDay />
  // 	);
  // }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const tagListData = _.map(this.state.tagDataArray, (tagData) => {
      return {
        tagId: tagData.tagId,
        auditTrailTime: tagData.auditTrailTime,
        userEmail: tagData.userEmail,
      };
    });

    // const { SearchBar } = Search;

    // const thArray = [
    // 	{
    // 		dataField: "tagId",
    // 		text: "Tag Id",
    // 		// (アクセス状況)
    // 		sort: true
    // 	},
    // 	{
    // 		dataField: "auditTrailTime",
    // 		text: "Audit Trail Time",
    // 		// (アクセス状況)
    // 		sort: true
    // 	},
    // 	{
    // 		dataField: "userEmail",
    // 		text: "User Email",
    // 		// (ハードウェア名)
    // 		sort: false
    // 	},
    // ];

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      paginationSize: 10,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: tagListData.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
      searchField: this.createCustomSearchField,
    };

    return (
      <div
        className="content"
        // style={{
        // 	maxWidth: "95%",
        // 	margin: "auto"
        // }}
      >
        {/* <div className="header">
                    <h2>{localizationStrings.tagManagementTitle}</h2>
                    <h4>{localizationStrings.tagDesc}</h4>
                </div> */}
        <div>
          <div>
            <div className="header">
              <div
                className="search"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <FormControl
                  style={{
                    width: "40%",
                    marginTop: "20px",
                    position: "relative",
                    top: "40px",
                  }}
                  className="content mediumDropDown"
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnChangeEvent}
                >
                  <option>-Select your Lock Serial-</option>
                  {this.renderDropdown()}
                </FormControl>
              </div>
              {/* <br /> */}
              {/* <br /> */}

              <BootstrapTable
                keyField="key"
                data={tagListData}
                bordered={false}
                options={options}
                search
                // loading={true}
                // overlay={overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' })}
                noDataIndication={this.loadingData()}
                // cellEdit={cellEditFactory({ mode: 'click' })}
                pagination={paginationFactory(options)}
                // {...props.baseProps}
              >
                <TableHeaderColumn dataField="tagId" dataSort>
                  {localizationStrings.tagIDTitle}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="auditTrailTime"
                  dataSort
                  dataFormat={this.dateTimeFormat}
                >
                  {localizationStrings.auditTrailTimeTitle}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="userEmail"
                  dataSort
                  // dataFormat={this.dateTimeFormat}
                >
                  {localizationStrings.userEmailTitle}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(TagAudit);
